import {
  CustomFieldType,
  IDataFieldValue,
  IFieldConfig,
} from "@shared/lib/types/briefInfluencerV2";
import { useEffect, useState } from "react";

interface UseBriefCustomFieldsFormProps {
  selectedField: IFieldConfig | null;
  isEditMode: boolean;
}

export function useBriefCustomFieldsForm({
  selectedField,
  isEditMode,
}: UseBriefCustomFieldsFormProps) {
  const [fieldName, setFieldName] = useState("");
  const [fieldType, setFieldType] = useState<CustomFieldType>(
    CustomFieldType.STRING
  );
  const [fieldDefault, setFieldDefault] = useState<IDataFieldValue | undefined>(
    undefined
  );
  const [dropdownOptions, setDropdownOptions] = useState<string[]>([""]);

  // Reset form when switching to create
  useEffect(() => {
    if (!isEditMode) {
      setFieldName("");
      setFieldType(CustomFieldType.STRING);
      setFieldDefault(undefined);
      setDropdownOptions([""]);
    }
  }, [isEditMode]);

  // Populate form when editing
  useEffect(() => {
    if (isEditMode && selectedField) {
      setFieldName(selectedField.displayName || selectedField.key || "");
      setFieldType(
        (selectedField.type as CustomFieldType) || CustomFieldType.STRING
      );
      const defaultValue = selectedField.defaultValue;
      if (
        typeof defaultValue === "string" ||
        typeof defaultValue === "number" ||
        (Array.isArray(defaultValue) &&
          (defaultValue.length === 0 ||
            typeof defaultValue[0] === "string" ||
            typeof defaultValue[0] === "number"))
      ) {
        setFieldDefault(defaultValue as string | number | string[]);
      } else {
        setFieldDefault(undefined);
      }
      setDropdownOptions(
        selectedField.dropdownOptions &&
          selectedField.dropdownOptions.length > 0
          ? selectedField.dropdownOptions
          : [""]
      );
    }
  }, [isEditMode, selectedField]);

  // Reset dropdownOptions and fieldDefault when fieldType changes
  // useEffect(() => {
  //   // Only reset if fieldType actually changed (not on initial mount)
  //   setDropdownOptions([""]);
  //   setFieldDefault(undefined);
  // }, [fieldType]);

  const handleAddOption = () => {
    setDropdownOptions([...dropdownOptions, ""]);
  };

  const handleOptionChange = (index: number, value: string) => {
    const newOptions = [...dropdownOptions];
    newOptions[index] = value;
    setDropdownOptions(newOptions);
  };

  const handleRemoveOption = (index: number) => {
    if (dropdownOptions.length > 1) {
      setDropdownOptions(dropdownOptions.filter((_, i) => i !== index));
    }
  };

  const resetForm = () => {
    setFieldName("");
    setFieldType(CustomFieldType.STRING);
    setFieldDefault(undefined);
    setDropdownOptions([""]);
  };

  return {
    fieldName,
    fieldType,
    fieldDefault,
    dropdownOptions,
    setFieldName,
    setFieldType,
    setFieldDefault,
    setDropdownOptions,
    handleAddOption,
    handleOptionChange,
    handleRemoveOption,
    resetForm,
  };
}
